import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ContactType,
  InfoClient,
} from '../../interface/company-client.interface';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { ContactInfoService } from '../../service/contact-info.service';

@Component({
  selector: 'app-add-new-contact',
  templateUrl: './add-new-contact.component.html',
  styleUrls: ['./add-new-contact.component.scss'],
})
export class AddNewContactComponent {
  public isLoading: boolean = false;
  public rutUrl: number;
  public update: boolean;
  public isNew: boolean = false;
  public hasContact: boolean = false;
  @ViewChild('select') select: MatSelect;
  @ViewChild('select2') select2: MatSelect;
  public allSelected: boolean = false;
  public allSelected2: boolean = false;

  rutForm: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddNewContactComponent>,
    private _userService: ContactInfoService,
    private route: ActivatedRoute,
    private configuracionRut: ConfigRutService
  ) {}

  public form = new FormGroup({
    nameContact: new FormControl<string | null>(''),
    lastNameContact: new FormControl<string | null>('', []),
    emailContact: new FormControl<string | null>(''),
    phoneContact: new FormControl<string | null>(''),
    fullRutContact: new FormControl<string>(''),
    preferredContact: new FormControl<string>(''),
    infoPreferences: new FormControl<string | null>(''),
  });

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const { client } = params;
      this.rutUrl = parseInt(client);
    });
    
    this.isNew = this.data.isNew;
    this.setForm(this.data.data);
  }

  inputRut(event) {
    const { formattedRut, validation } = this.configuracionRut.changeRut(event);
    this.form.controls['fullRutContact'].setValue(formattedRut);
    if (!validation) {
      this.form.controls['fullRutContact'].setErrors({
        invalidRut: false,
      });
    }    
    this.configuracionRut.transformStringRut(event.target.value);
    this.rutForm = formattedRut;
  }
  toggleAllSelection() {   
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }
  toggleAllSelection2() {   
    if (this.allSelected2) {      
      this.select2.options.forEach((item: MatOption) => item.select());
    } else {
      this.select2.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    let newStatus2 = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.select2.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus2 = false;
      }
    });
    this.allSelected = newStatus;
    this.allSelected2 = newStatus2;
  }
  contactType: ContactType[] = [
    { value: 'email', viewValue: 'Email' },
    { value: 'whatsapp', viewValue: 'Whatsapp' },
    { value: 'telefono', viewValue: 'Telefono' },
  ];
  preferences: ContactType[] = [
    { value: 'Factoring', viewValue: 'Factoring' },
    { value: 'Garantías', viewValue: 'Garantías' },
    { value: 'creditos', viewValue: 'Creditos' },
  ];
  private setForm(contact: InfoClient | undefined) {
    this.hasContact = contact != undefined;
    if (contact != undefined) {
      this.form.patchValue({
        fullRutContact: contact.fullRutContact,
        nameContact: contact.nameContact,
        emailContact: contact.emailContact,
        phoneContact: contact.phoneContact,
        infoPreferences: contact.infoPreferences,
        lastNameContact: contact.lastNameContact,
        preferredContact: contact.preferredContact,
      });
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  get f() {
    return this.form.controls;
  }

  public submitForm() {
    const preferredContact = this.form
      .get('preferredContact')
      ?.value.toString();
    const contactType = this.form
      .get('infoPreferences')
      ?.value.toString();

    const request: InfoClient = {
      nameContact: this.form.get('nameContact')?.value,
      lastNameContact: this.form.get('lastNameContact')?.value,
      emailContact: this.form.get('emailContact')?.value,
      phoneContact: this.form.get('phoneContact')?.value,
      fullRutContact: this.form.get('fullRutContact')?.value,
      preferredContact: preferredContact,
      infoPreferences: contactType,
      originRegister: 'Contacto',
    };


    Swal.fire({
      title: 'Agregando Contacto',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        if (!this.isNew) {
          this._userService.UpdateInfoClient(request, this.data.data.contactCompaniesId).subscribe({
            next: (res) => {
              this.update = true;
              Swal.fire({
                title: 'Datos Contacto Actualizado',
                icon: 'success',
              }).then((res) => {
                if (res.isConfirmed) {
                  this.dialogRef.close(this.update);
                }
              });
            },
          });
        } else {
          this._userService.CreateInfoClient(request, this.rutUrl).subscribe({
            next: (res) => {
              this.update = true;
              Swal.fire({
                title: 'Datos Contacto Agregado',
                icon: 'success',
              }).then((res) => {
                if (res.isConfirmed) {
                  this.dialogRef.close(this.update);
                }
              });
            },
          });
        }
      },
    });
  }
}
